"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDiff = getDiff;
exports.getHorizontalCenterRatio = getHorizontalCenterRatio;
exports.getPinchScaleRatio = getPinchScaleRatio;
exports.getVerticalCenterRatio = getVerticalCenterRatio;
exports.getWheelScaleRatio = getWheelScaleRatio;
exports.isSpanValid = isSpanValid;
exports.preventDefault = preventDefault;
exports.zoomAtPoint = void 0;
/**
 * Helper to get the range (in percents of a reference range) corresponding to a given scale.
 * @param centerRatio {number} The ratio of the point that should not move between the previous and next range.
 * @param scaleRatio {number} The target scale ratio.
 * @returns The range to display.
 */
const zoomAtPoint = (centerRatio, scaleRatio, currentZoomData, options) => {
  const MIN_RANGE = options.minStart;
  const MAX_RANGE = options.maxEnd;
  const MIN_ALLOWED_SPAN = options.minSpan;
  const minRange = currentZoomData.start;
  const maxRange = currentZoomData.end;
  const point = minRange + centerRatio * (maxRange - minRange);
  let newMinRange = (minRange + point * (scaleRatio - 1)) / scaleRatio;
  let newMaxRange = (maxRange + point * (scaleRatio - 1)) / scaleRatio;
  let minSpillover = 0;
  let maxSpillover = 0;
  if (newMinRange < MIN_RANGE) {
    minSpillover = Math.abs(newMinRange);
    newMinRange = MIN_RANGE;
  }
  if (newMaxRange > MAX_RANGE) {
    maxSpillover = Math.abs(newMaxRange - MAX_RANGE);
    newMaxRange = MAX_RANGE;
  }
  if (minSpillover > 0 && maxSpillover > 0) {
    return [MIN_RANGE, MAX_RANGE];
  }
  newMaxRange += minSpillover;
  newMinRange -= maxSpillover;
  newMinRange = Math.min(MAX_RANGE - MIN_ALLOWED_SPAN, Math.max(MIN_RANGE, newMinRange));
  newMaxRange = Math.max(MIN_ALLOWED_SPAN, Math.min(MAX_RANGE, newMaxRange));
  return [newMinRange, newMaxRange];
};

/**
 * Checks if the new span is valid.
 */
exports.zoomAtPoint = zoomAtPoint;
function isSpanValid(minRange, maxRange, isZoomIn, option) {
  const newSpanPercent = maxRange - minRange;
  if (isZoomIn && newSpanPercent < option.minSpan || !isZoomIn && newSpanPercent > option.maxSpan) {
    return false;
  }
  if (minRange < option.minStart || maxRange > option.maxEnd) {
    return false;
  }
  return true;
}
function getMultiplier(event) {
  const ctrlMultiplier = event.ctrlKey ? 3 : 1;

  // DeltaMode: 0 is pixel, 1 is line, 2 is page
  // This is defined by the browser.
  if (event.deltaMode === 1) {
    return 1 * ctrlMultiplier;
  }
  if (event.deltaMode) {
    return 10 * ctrlMultiplier;
  }
  return 0.2 * ctrlMultiplier;
}

/**
 * Get the scale ratio and if it's a zoom in or out from a wheel event.
 */
function getWheelScaleRatio(event, step) {
  const deltaY = -event.deltaY;
  const multiplier = getMultiplier(event);
  const scaledStep = step * multiplier * deltaY / 1000;
  // Clamp the scale ratio between 0.1 and 1.9 so that the zoom is not too big or too small.
  const scaleRatio = Math.min(Math.max(1 + scaledStep, 0.1), 1.9);
  const isZoomIn = deltaY > 0;
  return {
    scaleRatio,
    isZoomIn
  };
}

/**
 * Get the scale ratio and if it's a zoom in or out from a pinch gesture.
 */
function getPinchScaleRatio(curDiff, prevDiff, step) {
  const scaledStep = step / 1000;
  let scaleRatio = 0;
  let isZoomIn = false;
  const hasMoved = prevDiff > 0;
  if (hasMoved && curDiff > prevDiff) {
    // The distance between the two pointers has increased
    scaleRatio = 1 + scaledStep;
    isZoomIn = true;
  }
  if (hasMoved && curDiff < prevDiff) {
    // The distance between the two pointers has decreased
    scaleRatio = 1 - scaledStep;
    isZoomIn = false;
  }
  return {
    scaleRatio,
    isZoomIn
  };
}
function getDiff(eventCache) {
  const [firstEvent, secondEvent] = eventCache;
  return Math.hypot(firstEvent.pageX - secondEvent.pageX, firstEvent.pageY - secondEvent.pageY);
}

/**
 * Get the ratio of the point in the horizontal center of the area.
 */
function getHorizontalCenterRatio(point, area) {
  const {
    left,
    width
  } = area;
  return (point.x - left) / width;
}
function preventDefault(event) {
  event.preventDefault();
}
function getVerticalCenterRatio(point, area) {
  const {
    top,
    height
  } = area;
  return (point.y - top) / height * -1 + 1;
}